// =================================================================================
// 功能一：轮播功能初始化
// =================================================================================
function initCarousel() {
    const leftButton = document.querySelector('.may-also-like-button-left');
    const rightButton = document.querySelector('.may-also-like-button-right');
    const carouselItems = document.querySelectorAll('.may-also-like-wrapper-item');
    const totalItems = carouselItems.length;
    
    if (totalItems > 0 && leftButton && rightButton) {
      // 移除之前的事件监听器（如果存在）
      const newLeftButton = leftButton.cloneNode(true);
      const newRightButton = rightButton.cloneNode(true);
      leftButton.parentNode.replaceChild(newLeftButton, leftButton);
      rightButton.parentNode.replaceChild(newRightButton, rightButton);
      
      if (totalItems <= 1) {
        newLeftButton.classList.add('disabled-button');
        newRightButton.classList.add('disabled-button');
        carouselItems.forEach((item, index) => item.classList.toggle('hidden-como', index !== 0));
      } else {
        let currentIndex = 0;
        const updateCarouselState = () => {
          carouselItems.forEach((item, index) => item.classList.toggle('hidden-como', index !== currentIndex));
          newLeftButton.classList.toggle('disabled-button', currentIndex === 0);
          newRightButton.classList.toggle('disabled-button', currentIndex === totalItems - 1);
        };
        newRightButton.addEventListener('click', () => { if (currentIndex < totalItems - 1) { currentIndex++; updateCarouselState(); } });
        newLeftButton.addEventListener('click', () => { if (currentIndex > 0) { currentIndex--; updateCarouselState(); } });
        updateCarouselState();
      }
    }
}

// 监听推荐产品加载完成
function waitForRecommendations() {
    const recommendationsContainer = document.querySelector('.may-also-like-recommendations');
    if (!recommendationsContainer) return;
    
    // 使用 MutationObserver 监听 DOM 变化
    const observer = new MutationObserver((mutations) => {
        const carouselItems = document.querySelectorAll('.may-also-like-wrapper-item');
        if (carouselItems.length > 0) {
            initCarousel();
            observer.disconnect(); // 初始化后停止观察
        }
    });
    
    // 开始观察
    observer.observe(recommendationsContainer, {
        childList: true,
        subtree: true
    });
    
    // 立即检查一次（以防产品已经加载完成）
    setTimeout(() => {
        const carouselItems = document.querySelectorAll('.may-also-like-wrapper-item');
        if (carouselItems.length > 0) {
            initCarousel();
            observer.disconnect();
        }
    }, 100);
}

document.addEventListener('DOMContentLoaded', () => {
    // 等待推荐产品加载完成后再初始化轮播
    waitForRecommendations();
    
    // 也立即尝试初始化（以防产品已经存在）
    initCarousel();

    // =================================================================================
    // 功能二：捆绑加购的统一逻辑 (最终精简版)
    // =================================================================================
    
    function getItemsToAdd() {
      const productForm = document.querySelector('product-form .form[data-type="add-to-cart-form"]');
      if (!productForm) { return null; }
      const items = [];
      const mainVariantIdInput = productForm.querySelector('input[name="id"]');
      if (mainVariantIdInput && mainVariantIdInput.value) {
        items.push({ id: mainVariantIdInput.value, quantity: 1 });
      } else { return null; }
      const checkedAddons = document.querySelectorAll('.como-may-also-like-checkbox:checked');
      checkedAddons.forEach(checkbox => {
        const addonVariantId = checkbox.dataset.variantId;
        if (addonVariantId && addonVariantId !== 'null' && addonVariantId.trim() !== '') {
          items.push({ id: addonVariantId, quantity: 1 });
        }
      });
      return items;
    }

    function performAddToCart(event) {
      event.preventDefault(); 
      const itemsToAdd = getItemsToAdd();
      if (!itemsToAdd || itemsToAdd.length === 0) { return; }
      
      const submitButton = event.currentTarget;
      submitButton.classList.add('loading');
      submitButton.disabled = true;

      const formData = new FormData();
      itemsToAdd.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity);
      });
      
      // 【最终关键修正】只请求绝对不会出错的 section：购物车图标角标
      formData.append('sections', 'cart-icon-bubble');
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || '服务器拒绝了该请求。');
          });
        }
        return response.json();
      })
      .then((parsedState) => {
        // --- 【最终关键修正】我们自己动手，只更新购物车图标角标 ---
        const bubbleElement = document.getElementById('cart-icon-bubble');
        const bubbleHtml = parsedState.sections ? parsedState.sections['cart-icon-bubble'] : '';

        if (bubbleElement && bubbleHtml) {
          // 我们直接用返回的整个HTML片段替换，因为Dawn主题的这个片段很简单
          bubbleElement.innerHTML = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section').innerHTML;
        }
      })
      .catch((error) => {
        console.error('添加到购物车时发生错误:', error);
        alert(`添加到购物车失败: ${error.message}`);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.disabled = false;
      });
    }

    function performBuyNow(event) {
        event.preventDefault();
        const itemsToAdd = getItemsToAdd();
        if (!itemsToAdd) return;
        const submitButton = event.currentTarget;
        submitButton.classList.add('loading');
        submitButton.disabled = true;
        const checkoutUrlParts = itemsToAdd.map(item => `${item.id}:${item.quantity}`);
        const checkoutUrl = `/cart/${checkoutUrlParts.join(',')}`;
        window.location.href = checkoutUrl;
    }

    // --- 事件绑定 (无变化) ---
    const originalAddToCartButton = document.querySelector('.product-form__submit');
    const originalBuyNowButton = document.querySelector('.shopify-payment-button .shopify-payment-button__button');
    const fixedAddToCartButton = document.querySelector('.fixed-addCart-buyNow-button .buyNow-button-addCart');
    const fixedBuyNowButton = document.querySelector('.fixed-addCart-buyNow-button .buyNow-button-buyNow');
    if (originalAddToCartButton) originalAddToCartButton.addEventListener('click', performAddToCart);
    if (fixedAddToCartButton) fixedAddToCartButton.addEventListener('click', performAddToCart);
    if (originalBuyNowButton) originalBuyNowButton.addEventListener('click', performBuyNow);
    if (fixedBuyNowButton) fixedBuyNowButton.addEventListener('click', performBuyNow);

    const productForm = document.querySelector('product-form .form[data-type="add-to-cart-form"]');
    if (productForm) {
      productForm.addEventListener('submit', (event) => event.preventDefault());
    }
});